import * as RX from 'reactxp';
import { createStore } from 'redux';

import * as ReactGA from './modules/google_analytics';
import Router from './modules/routing';

import Contact from './pages/contact';
import EmergencyDepartment from './pages/emergency_department';
import Feedback from './pages/feedback';
import HomePage from './pages/home';
import Results from './pages/results';
import SymptomChecker from './pages/symptom_checker';
import urgentCare from './pages/urgent_care';

import { emergencyMessage } from './utils/api'
import t from './utils/i18n';
import { urls } from './utils/urls';

import rootReducer from './reducers';

import axios from 'axios';

ReactGA.register('UA-142413509-1');

const store = createStore(rootReducer);

const menuItems = [
  {
    items: [
      {
        title: t('menu.symptomChecker'),
        url: '/symptom-checker',
      },
      {
        title: t('menu.home'),
        url: '/',
      },
    ],
    title: t('menu.mainTitle'),
    url: '/symptom-checker',
  },
  {
    items: [
      {
        // external: true,
        // title: t('menu.urgentCare.title'),
        // url: urls.urgentCare
        title: t('menu.urgentCare.title'),
        url: urls.urgentCare,
      },
      {
        title: t('menu.primaryCare.title'),
        url: urls.primaryCare,
      },
      {
        title: t('menu.specialtyCare.title'),
        url: urls.specialtyCare,
      },
      {
        title: t('menu.testing.title'),
        url: urls.testing,
      },
    ],
    title: t('menu.scheduling'),
  },
  {
    items: [
      {
        title: t('menu.emergencyDepartment.title'),
        url: '/emergency-department',
      },
      {
        title: t('menu.primaryAndSpecialty'),
        url: urls.primaryAndSpcialty,
      },
      {
        title: t('menu.contact'),
        url: '/contact',
      },
      {
        title: t('menu.feedback'),
        url: '/feedback',
      },
    ],
    title: t('menu.general'),
  },
];

const routes = {
  notWrappedRoutes: [{
    component: HomePage,
    exact: true,
    path: '/',
  }],
  wrappedRoutes: [{
    component: SymptomChecker,
    path: '/symptom-checker',
  },
  {
    component: Results,
    path: '/results',
  },
  {
    component: Feedback,
    path: '/feedback',
  },
  {
    component: urgentCare,
    path: '/urgent-care',
  },
  {
    component: Contact,
    path: '/contact',
  },
  {
    component: EmergencyDepartment,
    path: '/emergency-department',
  }],
};

class App extends RX.Component<RX.CommonProps, RX.CommonProps> {

  constructor(props: any) {
    super(props);
  }

  public componentDidMount() {
    axios({
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
      method: 'GET',
      url: emergencyMessage
    }).then((response: any) => {
      if (response.data && response.data.message) {
        store.dispatch({ type: 'SET_EMERGENCY_BANNER', html: response.data.message });
      }
    })
  }

  public render() {
    return (
      <Router { ... { store, menuItems, routes }} />
    );
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx